import { LazyAction, LazyBootModule } from 'owa-bundling-light';

export let lazyStashSessionDataResponses = new LazyAction(
    new LazyBootModule(
        () => import(/* webpackChunkName: "SessionDataStash"*/ './stashSessionDataResponses')
    ),
    m => m.stashSessionDataResponses
);

export let lazyTryGetConversationRowsFromResponse = new LazyAction(
    new LazyBootModule(
        () =>
            import(
                /* webpackChunkName: "StashConversationRows"*/ './tryGetConversationRowsFromResponse'
            )
    ),
    m => m.tryGetConversationRowsFromResponse
);
